import React from 'react';

import Text from '@amzn/meridian/text';

interface SummaryBulletsProps {
    points: string[];
}

/**
 * Component to display summary points in bullet format.
 */
export const SummaryBullets: React.FC<SummaryBulletsProps> = ({ points }) => {
    if (!points) return null;

    return (
        <Text tag="ul">
            {points.map((point, index) => (
                <li key={index}>{point}</li>
            ))}
        </Text>
    );
};
